module.exports = __webpack_public_path__ + "static/media/img2.1f9a106a.png";